// extracted by mini-css-extract-plugin
export default {"header":"VirtualTable_header__uZ2Xt","headerCell":"VirtualTable_headerCell__aT94v","virtualTableCell":"VirtualTable_virtualTableCell__10-Uu"};